import { get } from '../../../utils/get';
export var getCurrentLanguage = function (item) { return get(item, 'context.currLangCode'); };
export var getCurrentSeoLang = function (item) { return get(item, 'context.seoLang'); };
